import { getStore } from '../store/chatStore';
import getEmailAddressFromSipUri from '../presenceManager/getEmailAddressFromSipUri';

export default function getRecipientDisplayName(sipUri: string): string {
    return getStore().participantCache.get(sipUri) || getEmailAddressFromSipUri(sipUri);
}
